// Module
var code = "<div class=\"vertical-layout-framework\">\n    <div class=\"layout-aside\" ng-transclude=\"aside\"></div>\n    <div class=\"layout-toggle-element\" ng-click=\"dlgToggleLayout()\"></div>\n    <div class=\"layout-content\" ng-transclude=\"content\"></div>\n</div>";
// Exports
module.exports = code;